// This file is automatically generated. Do not edit manually.

import { ReclamationState } from "src/api/generated/erp/db/types/enums/reclamationState";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { ReclamationView } from "src/api/generated/erp/db/types/tables/reclamationView";
import { ErpAppUser } from "src/api/generated/erp/db/types/tables/erpAppUser";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ReclamationQueryApi {
	export async function getReclamations(args: {
		states?: Array<ReclamationState>;
		reclamationId?: number | null | undefined;
		customerOrderId?: number | null | undefined;
		responsiblePersonId?: number | null | undefined;
		searchQuery?: string;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<ReclamationView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/getReclamations",
			method: "POST",
			data: {
				states: args.states,
				reclamationId: args.reclamationId,
				customerOrderId: args.customerOrderId,
				responsiblePersonId: args.responsiblePersonId,
				searchQuery: args.searchQuery,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<ReclamationView>;
	}

	export async function getResponsiblePersonOptions(): Promise<Array<ErpAppUser>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/getResponsiblePersonOptions",
			method: "POST",
			data: {},
		});
		return response as Array<ErpAppUser>;
	}
}
